
import {
    OBSERVACIO_FORMULARI_INSERIR_EN_CURS,
    OBSERVACIO_FORMULARI_INSERIR_FINALITZADA,
    OBSERVACIO_INICIALITZAR,
    OBSERVACIO_FORMULARI_INICIALITZAR
} from '../../../actions/actionTypes';

const ESTAT_INICIAL_PETICIO_INSERIR_EN_CURS = false;

const peticioInserirEnCurs = (state = ESTAT_INICIAL_PETICIO_INSERIR_EN_CURS, action) => {

    switch (action.type) {
        case OBSERVACIO_FORMULARI_INSERIR_EN_CURS:
            return true;
        case OBSERVACIO_FORMULARI_INSERIR_FINALITZADA:
            return false;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_PETICIO_INSERIR_EN_CURS;
        case OBSERVACIO_FORMULARI_INICIALITZAR:
            return ESTAT_INICIAL_PETICIO_INSERIR_EN_CURS;
        default:
            return state;
    }
};

export default peticioInserirEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/peticioInserirEnCurs.js